import React from 'react';
import { CloudOff, Loader2, CheckCircle2 } from 'lucide-react';
import { useOfflineQueue } from '@/hooks/useOfflineQueue';

/** Fixed bottom-right indicator: shows offline state and queued actions. */
export function OfflineIndicator() {
  const { online, pending, flushing } = useOfflineQueue();

  if (online && pending === 0 && !flushing) return null;

  let label;
  let icon;
  let container = 'bg-amber-50 border-amber-200 text-amber-900';

  if (!online) {
    icon = <CloudOff className="w-4 h-4 shrink-0" />;
    label = pending > 0
      ? `Offline — ${pending} action${pending === 1 ? '' : 's'} queued`
      : 'Offline — you can keep working';
  } else if (flushing) {
    icon = <Loader2 className="w-4 h-4 shrink-0 animate-spin" />;
    label = `Syncing ${pending} queued action${pending === 1 ? '' : 's'}…`;
    container = 'bg-blue-50 border-blue-200 text-blue-900';
  } else {
    icon = <CheckCircle2 className="w-4 h-4 shrink-0" />;
    label = 'All synced';
    container = 'bg-emerald-50 border-emerald-200 text-emerald-900';
  }

  return (
    <div
      className={`fixed bottom-20 lg:bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-2 px-3 py-2 border rounded-sm shadow-sm text-xs font-medium max-w-[92vw] ${container}`}
      role="status"
      aria-live="polite"
      data-testid="offline-indicator"
    >
      {icon}
      <span className="truncate">{label}</span>
    </div>
  );
}
